import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Beer } from "../../../data/types";
import { Dispatch, SetStateAction, useState } from "react";
import { updateBeer } from "../../../services/firestore";
import "./Sortable.scss";

interface SortableItemProps {
  beer: Beer;
  setBeers: Dispatch<SetStateAction<Beer[]>>;
  onDelete: (id: string) => void;
}

const SortableItem: React.FC<SortableItemProps> = ({
  beer,
  setBeers,
  onDelete,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: beer.id });

  const [editingBeerId, setEditingBeerId] = useState<string | null>(null);
  const [editData, setEditData] = useState<Beer | null>(null);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: "grab",
  };

  const handleEditClick = (beer: Beer) => {
    console.log("edit");

    setEditingBeerId(editingBeerId === beer.id ? null : beer.id);
    setEditData(beer);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setEditData((prev) => {
      if (!prev) return prev;

      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      } as Beer;
    });
  };

  const handleSave = async () => {
    if (!editData) return;
    await updateBeer(editData as Beer);
    setBeers((prevBeers) =>
      prevBeers.map((beer) => (beer.id === editData.id ? editData : beer))
    );
    setEditingBeerId(null);
  };

  const handleCancel = () => {
    setEditingBeerId(null);
  };

  return (
    <li ref={setNodeRef} style={style} className="beer-list__item">
      <div
        className="beer-list__content"
        onClick={(e) => {
          e.stopPropagation();
          handleEditClick(beer);
        }}
      >
        <div className="beer-list__drag-handle" {...listeners} {...attributes}>
          ⠿
        </div>
        <p>
          {beer.name}
          {beer.available === false && (
            <span className="beer-list__unavailable-badge">Ej i lager</span>
          )}
        </p>
        <div className="beer-list__buttons">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleEditClick(beer);
            }}
            className="beer-list__button"
          >
            Edit
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(beer.id);
            }}
            className="beer-list__button beer-list__button--delete"
          >
            Delete
          </button>
        </div>
      </div>
      {editingBeerId === beer.id && editData && (
        <div className="beer-list__edit-dropdown">
          <input
            type="text"
            name="name"
            value={editData.name || ""}
            onChange={handleChange}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <input
            type="text"
            name="abv"
            value={editData.abv || ""}
            onChange={handleChange}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <input
            type="text"
            name="type"
            value={editData.type || ""}
            onChange={handleChange}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <input
            type="text"
            name="untappdLink"
            placeholder="Untappd link"
            value={editData.untappdLink || ""}
            onChange={handleChange}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <input
            type="text"
            name="image"
            value={editData.image || ""}
            onChange={handleChange}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
          <input
            type="text"
            name="availability"
            value={editData.availability || ""}
            onChange={handleChange}
            onClick={(e) => {
              e.stopPropagation();
            }}
            placeholder="Avilable at"
          />

          <textarea
            name="description"
            value={editData.description || ""}
            onChange={handleChange}
            placeholder="Description"
            onClick={(e) => {
              e.stopPropagation();
            }}
          />

          <textarea
            name="funFact"
            value={editData.funFact || ""}
            onChange={handleChange}
            placeholder="Fun fact"
            onClick={(e) => {
              e.stopPropagation();
            }}
          />

          <label
            className="beer-list__availability-toggle"
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="checkbox"
              name="available"
              checked={editData.available !== false}
              onChange={handleChange}
            />
            Tillgänglig för custom flight
          </label>

          <div className="beer-list__edit-buttons">
            <button
              className="beer-list__edit-buttons--save"
              onClick={(e) => {
                e.stopPropagation();
                handleSave();
              }}
            >
              Save
            </button>
            <button
              className="beer-list__edit-buttons--cancel"
              onClick={(e) => {
                e.stopPropagation();
                handleCancel();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </li>
  );
};

export default SortableItem;
